import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';
import ValidationErrorMessage from '../notifications/ValidationErrorMessage';

// ActionCreators

import { changeData } from '@actions/ssap/ssapActionCreators';

// Utils

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { parseFieldChangeArgs } from '@utils/ssap/parseFieldChangeArgs';
import { preventerTools } from '@utils/tools/preventerTools';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '@constants/inputs/validationErrorMessages';




const Page2_28_E3 = props => {

    const {
        buttonContainer: ButtonContainer,
        currentHhm,
        currentHhm: {
            name,
            taxHouseholdComposition: {
                hasSpouse,
                spouseOnApplication
            }
        },
        data,
        form,
        formName,
        hhmIndex,
        householdMembers: {
            length : hhmsQty
        }
    } = props;

    const {
        isFormSubmitted
    } = preventerTools.provideObject(form[formName]);

    const onFieldChange = (...args) => {
        const { name, newData, value } = parseFieldChangeArgs(args);

        const newState = { ...data };

        if(name === 'hasSpouse' && value === false) {
            newData.taxHouseholdComposition.spouseOnApplication = null;
        }

        newState.taxHousehold.householdMember[hhmIndex] = newData;

        props.actions.changeData(newState);
    };

    const replacements = {
        personName: (
            <strong>
                { normalizeNameOfPerson(name) }
            </strong>
        )
    };

    const getButtons = isSpouseOnApplication => {

        switch(true) {
            case isSpouseOnApplication === true:
                return (
                    <Fragment>
                        <FormattedMessage 
                            id = 'ssap.family_household.marital_status.select_spouse'
                            values = { replacements }
                            tagName = 'p'
                        />
                        <ButtonContainer
                            args = { [ ] }
                            type = 'fixRelationshipButton'
                        />
                    </Fragment>
                );
            case isSpouseOnApplication === false || (hasSpouse && hhmsQty === 1):
                return (
                    <Fragment>
                        <p className = 'required-true' >
                            <FormattedMessage
                                id = 'ssap.family_household.marital_status.spouse_info'
                                values = { replacements }
                            />
                        </p>
                        <ButtonContainer
                            args = { [ ] }
                            type = 'updateInformationButton'
                        />
                    </Fragment>
                );
            default:
                return null;
        }
    };

    const topLevelValidity = hasSpouse !== true;

    return (
        <div
            className = 'fade-in'
            id = 'fhMaritalStatus'
        >
            <Fragment>
                <div className = 'subsection' >
                    <Form
                        { ...{
                            formName,
                            topLevelValidity
                        } }
                    >
                        <ValidationErrorMessage
                            isVisible = { isFormSubmitted && !topLevelValidity && hasSpouse === true }
                            messageText = { VALIDATION_ERROR_MESSAGES.PROVIDE_SPOUSE }
                            errorClasses = { [ 'margin-l-0' ] }
                        />
                        <UniversalInput
                            legend = { {
                                dataInstructions: 'instructional_text.who_is_married',
                                legendText: 'ssap.input.legend.is_married',
                                legendTextReplacements: replacements
                            } }
                            label = { {
                                ulClass: [ 'margin-b-20' ],
                                showRequiredIcon: true
                            } }
                            inputData = { {
                                isInputRequired: true,
                                type: INPUT_TYPES.RADIO_BUTTONS,
                                name: 'hasSpouse',
                                value: hasSpouse,
                                options: DROPDOWN_OPTIONS.YES_NO,
                                validationType: VALIDATION_TYPES.CHOSEN,
                                currentData: currentHhm,
                                fields: [ 'taxHouseholdComposition' ]
                            } }
                            inputActions = { {
                                onFieldChange
                            } }
                            errorClasses = { [ 'margin-l-0' ] }
                        />

                        {
                            hasSpouse && hhmsQty > 1 &&

                            <UniversalInput
                                legend = { {
                                    legendText: 'ssap.input.legend.who_is_spouse',
                                    legendTextReplacements: replacements
                                } }
                                label = { {
                                    ulClass: [ 'margin-b-20' ],
                                    showRequiredIcon: true
                                } }
                                inputData = { {
                                    isInputRequired: true,
                                    type: INPUT_TYPES.RADIO_BUTTONS,
                                    name: 'spouseOnApplication',
                                    value: spouseOnApplication,
                                    options: DROPDOWN_OPTIONS.SPOUSE_ON_APPLICATION,
                                    validationType: VALIDATION_TYPES.CHOSEN,
                                    currentData: currentHhm,
                                    fields: [ 'taxHouseholdComposition' ]
                                } }
                                inputActions = { {
                                    onFieldChange
                                } }
                                errorClasses = { [ 'margin-l-0' ] }
                            />
                        }
                    </Form>
                    {
                        getButtons(spouseOnApplication)
                    }
                </div>
            </Fragment>
        </div>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    form: state.ssap.form,

    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page2_28_E3);
